export default __webpack_public_path__ + "static/media/dejado-logo.d7c8959e.png";